<template>
  <cookie-law
    ref="consent"
    @accept="accept"
    storage-type="cookies"
    storage-name="cookieName"
    theme="dark-lime"
  >
    <template #default="{ accept, close }">
      <div class="Cookie__content">
        <!-- New cookie consent for NAF: -->
        <p>
          <b>{{ $t("cookies.Cookies") }}</b>
        </p>
        <!-- <p><b>{{ $t('cookies.General') }}</b></p> -->
        <p style="text-align: justify;">{{ $t("cookies.General_content") }}</p>
        <br />
        <p>
          <b>{{ $t("cookies.Matomo") }}</b>
        </p>
        <p style="text-align: justify;">{{ $t("cookies.Matomo_content") }}</p>
        <br />
        <table style="width:100%">
          <tr>
            <th style="color: #FFFFFF" scope="col">
              {{ $t("cookies.Cookie") }}
            </th>
            <th style="color: #FFFFFF" scope="col">
              {{ $t("cookies.Expiry") }}
            </th>
          </tr>
          <tr>
            <td>_pk_id</td>
            <td>13 {{ $t("cookies.months") }}</td>
          </tr>
          <tr>
            <td>_pk_rf</td>
            <td>6 {{ $t("cookies.months") }}</td>
          </tr>
          <tr>
            <td>_pk_ses</td>
            <td>30 {{ $t("cookies.minutes") }}</td>
          </tr>
          <tr>
            <td>_pk_cvar</td>
            <td>30 {{ $t("cookies.months") }}</td>
          </tr>
        </table>
      </div>
      <!-- Old and simple cookie consent: -->
      <!--       <div class="Cookie__content">
	<p>{{ $t('This website uses cookies to ensure you get the best experience on our website.') }}</p>
      </div> -->
      <div class="Cookie__buttons">
        <button class="Cookie__button" @click="close">
          <span>{{ $t("No, thanks") }}</span>
        </button>
        <button class="Cookie__button" @click="accept">
          <span>{{ $t("I accept") }}</span>
        </button>
      </div>
    </template>
  </cookie-law>
</template>

<script>
import CookieLaw from "vue-cookie-law";

import config from "@/config";

const SCRIPT = `
 var _paq = window._paq = window._paq || [];

  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */

  _paq.push(['trackPageView']);

  _paq.push(['enableLinkTracking']);

  (function() {

    var u="//japetus.narc.fi/piwik/";

    _paq.push(['setTrackerUrl', u+'matomo.php']);

    _paq.push(['setSiteId', '62']);

    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];

    g.type='text/javascript'; g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);

  })();
 `;

export default {
  components: { CookieLaw },
  computed: {
    cookieName() {
      return config.consentCookie;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.consent) {
        if (this.$refs.consent.getVisited()) {
          this.insertScript();
        }
      }
    });
  },
  methods: {
    accept() {
      this.insertScript();
    },
    insertScript() {
      let script = document.querySelector(".js-analytics");
      if (script !== null) return;
      script = document.createElement("script");
      script.classList.add("js-analytics");
      script.textContent = SCRIPT;
    
      document.head.appendChild(script);
  
    },
  },
};
</script>
